import React from "react";
import CssClasses from "./FullscreenLoader.css";

const FullscreenLoader = props => {
  //todo: makni
  return null;

  let classes = [CssClasses.container];

  if (props.isConnectionError) {
    classes.push(CssClasses.darkerBackground);
  }

  if (props.withTransparentBackground) {
    classes.push(CssClasses.transparentBackground);
  }

  return (
    <div className={[classes.join(" ")]}>
      <div className={CssClasses.preloader}>
        <div className={CssClasses.loader} />
      </div>

      {props.errorMessage && props.errorMessage !== "" ? (
        <div className={CssClasses.message}>{props.errorMessage}</div>
      ) : null}
    </div>
  );
};

export default FullscreenLoader;



// WEBPACK FOOTER //
// ./src/Components/UI/FullscreenLoader/FullscreenLoader.js